import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PaginationService } from '@shared/services/pagination/pagination.service';
import { Subscription } from 'rxjs';

import '@shared/components/pagination/ngx-bootstrap-pagination-init.patch';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaginationComponent implements OnInit, OnDestroy {
  @Input() public pagination: PaginationService<any>;
  public totalEntries: number;

  private entriesSubscription: Subscription;

  constructor() {}

  ngOnInit(): void {
    this.totalEntries = 0;
    this.entriesSubscription = this.pagination.entries.subscribe(
      (totalEntries: number) => {
        this.totalEntries = totalEntries;
      }
    );

    this.pagination.checkAndLoadPage(this.pagination.currentPage);
  }

  ngOnDestroy(): void {
    this.entriesSubscription?.unsubscribe();
  }

  public onPageChange(event: any) {
    this.pagination.checkAndLoadPage(event.page);
  }
}
